(function(angular) {
    'use strict';

    angular.module('wtApp.wtTracking.tracking', []).constant('PATH_ENDING', ['overview', 'edit', 'create']);
})(window.angular);
